const colors = {
  form: {
    formInputLabel: {
      color: '#235373',
    },
  },
  settings: {
    closeButton: {
      color: '#9e9e9e',
    },
    toggleButton: {
      color: '#70a040',
    },
    checkbox: {
      color: '#70a040',
    },
  },
};

export default colors;
